'use client';

import { useEffect, useRef } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';
import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';

export default function useSaveToListInstallPrompt(isListToastOpen: boolean) {
  const user = useUser();
  const experiments = useExperiments();
  const sendSaveInstallPromptExposure = useExposureEvent('web-growth-rm-app-install-prompt-save');
  const enableSaveInstallPromptTreatment = experiments['web-growth-rm-app-install-prompt-save']?.value === 'treatment';
  const [showSaveInstallPrompt, setShowSaveInstallPrompt] = useInstallPrompt('contextual-install-prompt', false);
  const wasToastOpenRef = useRef(false);

  // Show the install prompt when the save toast closes
  useEffect(() => {
    if (!user) {
      return;
    }

    if (isListToastOpen) {
      wasToastOpenRef.current = true;
    } else if (!isListToastOpen && wasToastOpenRef.current) {
      sendSaveInstallPromptExposure();
      wasToastOpenRef.current = false;

      if (enableSaveInstallPromptTreatment) {
        setShowSaveInstallPrompt(true);
      }
    }
  }, [enableSaveInstallPromptTreatment, isListToastOpen, sendSaveInstallPromptExposure, setShowSaveInstallPrompt, user]);

  return { showSaveInstallPrompt, setShowSaveInstallPrompt };
}
